import { logUnhandledError, logPromiseRejection } from './errorLogger';

// Setup global error handlers
export const setupGlobalErrorHandlers = (): void => {
  // Handle uncaught errors
  window.onerror = (
    message: string | Event,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: Error
  ): boolean => {
    const errorMessage = typeof message === 'string' ? message : 'Unknown error';

    // Don't log errors from browser extensions or external scripts
    if (source && (source.includes('chrome-extension') || source.includes('moz-extension'))) {
      return false;
    }

    logUnhandledError(errorMessage, source, lineno, colno, error);

    // Return false to let the default handler run as well
    return false;
  };

  // Handle unhandled promise rejections
  window.onunhandledrejection = (event: PromiseRejectionEvent): void => {
    logPromiseRejection(event.reason);
  };

  console.log('[ErrorHandlers] Global error handlers initialized');
};

// Remove global error handlers (for cleanup)
export const removeGlobalErrorHandlers = (): void => {
  window.onerror = null;
  window.onunhandledrejection = null;
};
